import { createFileRoute, redirect } from '@tanstack/react-router';
import { ModifyGenresPage } from '../components/profile/settings/ModifyGenresPage';

export const Route = createFileRoute('/profile/settings/genres')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: ModifyGenresPage,
});
